<template>
  <div class="profile-container">
    <!-- 欢迎标题 -->
    <div class="welcome-section">
      <h1 class="welcome-title">你好，{{ user.userName }}！</h1>
      <p class="welcome-subtitle">欢迎回到送呗Songbay管理系统</p>
    </div>

    <!-- 用户信息卡片 -->
    <el-card class="user-info-card">
      <div class="user-info-content">
        <div class="avatar-section" @click="updateAvatar(user.avatar)">
          <el-avatar :size="100" :src="user.avatar" class="user-avatar"></el-avatar>
          <div class="avatar-overlay">
            <i class="el-icon-camera"></i>
            <span>更换头像</span>
          </div>
        </div>

        <div class="info-section">
          <div class="info-header">
            <h2 class="user-name">{{ user.userName }}</h2>
            <el-tag type="success" size="medium">{{ user.roleName }}</el-tag>
          </div>

          <el-descriptions :column="3" class="user-descriptions">
            <template slot="extra">
              <el-button type="primary" size="small" icon="el-icon-edit" @click="edit">编辑资料</el-button>
            </template>
            <el-descriptions-item label="手机号">
              <i class="el-icon-mobile-phone"></i> {{ user.userPhone }}
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <i class="el-icon-user"></i> {{ user.sex == '0' ? '男' : '女' }}
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">
              <i class="el-icon-message"></i> {{ user.email || '未设置' }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </el-card>

    <!-- 功能区域 -->
    <el-row :gutter="20">
      <!-- 左侧：设置面板 -->
      <el-col :span="16">
        <el-card class="function-card">
          <div slot="header" class="card-header">
            <i class="el-icon-setting"></i>
            <span>账户设置</span>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="修改密码" name="first">
              <el-form ref="pwdRules" :model="checkPwd" :rules="pwdRules" label-width="100px" class="password-form">
                <el-form-item label="旧密码" prop="oldPassword">
                  <el-input v-model="checkPwd.oldPassword" placeholder="请输入旧密码" type="password" show-password prefix-icon="el-icon-lock" />
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                  <el-input v-model="checkPwd.newPassword" placeholder="请输入新密码" type="password" show-password prefix-icon="el-icon-lock" />
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input v-model="checkPwd.confirmPassword" placeholder="请确认新密码" type="password" show-password prefix-icon="el-icon-lock" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submit">保存修改</el-button>
                  <el-button @click="resetPwdForm">重置</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="修改邮箱" name="second">
              <div class="coming-soon">
                <i class="el-icon-bell"></i>
                <p>功能开发中，敬请期待...</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>

      <!-- 右侧：日历 -->
      <el-col :span="8">
        <el-card class="calendar-card">
          <div slot="header" class="card-header">
            <i class="el-icon-date"></i>
            <span>日历</span>
          </div>
          <el-calendar></el-calendar>
        </el-card>
      </el-col>
    </el-row>

    <!-- 更换头像对话框 -->
    <el-dialog title="更换头像" :visible.sync="addImgDialog" width="400px" center>
      <div class="avatar-dialog">
        <el-avatar :size="120" :src="this.newImg" class="preview-avatar"></el-avatar>
        <el-upload
          class="upload-btn"
          :action="uploadUrl"
          :on-success="pictureUpload"
          :show-file-list="false"
          accept="image/*">
          <el-button type="primary" icon="el-icon-upload">选择图片</el-button>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUploadImg">取 消</el-button>
        <el-button type="primary" @click="ConfirmUploadImg">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 基本信息修改对话框 -->
    <el-dialog title="编辑资料" :visible.sync="open" width="600px" append-to-body destroy-on-close>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户名" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="userPhone">
              <el-input v-model="form.userPhone" placeholder="请输入手机号" maxlength="11" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-radio-group v-model="form.sex">
                <el-radio label="0">男</el-radio>
                <el-radio label="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      form: {},
      uploadUrl: 'http://127.0.0.1:8080/upload',
      newImg: '',
      addImgDialog: false,
      checkPwd: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      user: {},
      activeName: 'first',
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 30, message: '用户名需在2~30个字符', trigger: 'blur' },
        ],
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: "请输入原密码！", trigger: "blur" },
          {
            pattern: '^\\d{6,12}$',
            message: "只能由6~12位数字组成！",
            trigger: "blur"
          }
        ],
        newPassword: [
          { required: true, message: "请输入新密码！", trigger: "blur" },
          {
            pattern: '^\\d{6,12}$',
            message: "只能由6~12位数字组成！",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          { required: true, message: "请确认密码！", trigger: "blur" },
          {
            pattern: '^\\d{6,12}$',
            message: "只能由6~12位数字组成！",
            trigger: "blur"
          },
          {
            validator: this.validateConfirmPassword, trigger: 'blur'
          }
        ],
      },
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    validateConfirmPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.checkPwd.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    
    resetPwdForm() {
      this.$refs["pwdRules"].resetFields();
    },
    
    async submit() {
      await this.$refs["pwdRules"].validate(async valid => {
        if (valid) {
          const { data: res } = await this.$http.post("user/updatePassword", this.checkPwd);
          if (res.code == 200) {
            this.$message.success('密码修改成功，请重新登录');
            setTimeout(() => {
              this.$router.push("/");
            }, 1500);
          } else if (res.code == 50002) {
            this.$message.error('原密码输入有误！')
          } else {
            this.$message.error('服务器异常!')
          }
        }
      });
    },
    
    cancel() {
      this.form = {};
      this.open = false;
    },
    
    async submitForm() {
      await this.$refs["form"].validate(async valid => {
        if (valid) {
          const { data: res } = await this.$http.post("user/updateBaseUser", this.form);
          if (res.code == 200) {
            this.getUser();
            this.open = false;
            this.$message.success('修改成功')
          } else if (res.code == 50003) {
            this.$message.error('用户手机号码已存在!')
          } else {
            this.$message.error('服务器异常!')
          }
        }
      });
    },
    
    edit() {
      this.form = { ...this.user };
      this.open = true;
    },
    
    updateAvatar(url) {
      this.newImg = url;
      this.addImgDialog = true;
    },
    
    closeUploadImg() {
      if (this.newImg != this.user.avatar) {
        this.$http.get("/deleteFile", {
          params: {
            imgUrl: this.newImg,
          }
        });
      }
      this.addImgDialog = false;
    },
    
    async ConfirmUploadImg() {
      if (!this.newImg) {
        this.$message.warning('请先上传图片');
        return;
      }
      
      let query = {
        avatar: this.newImg,
        id: this.user.id,
      }
      
      await this.$http.get("/deleteFile", {
        params: {
          imgUrl: this.user.avatar,
        }
      }).then(async () => {
        const { data: res } = await this.$http.post("user/updateImgUrl", query);
        if (res.code == 200) {
          this.getUser();
          this.addImgDialog = false;
          this.$message.success("头像更新成功！")
        } else {
          this.$message.error("服务器异常，请稍后再试！")
        }
      })
    },
    
    pictureUpload(file) {
      this.newImg = file.data;
    },
    
    async getUser() {
      const { data: res } = await this.$http.get("user/getUserByToken", {
        params: {
          token: window.sessionStorage.getItem("token"),
        }
      })
      this.user = res.data;
      this.newImg = res.data.avatar;
    },
    
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped>
.profile-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 欢迎区域 */
.welcome-section {
  margin-bottom: 24px;
}

.welcome-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.welcome-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

/* 用户信息卡片 */
.user-info-card {
  margin-bottom: 24px;
}

.user-info-content {
  display: flex;
  gap: 40px;
  align-items: center;
}

/* 头像区域 */
.avatar-section {
  position: relative;
  cursor: pointer;
}

.user-avatar {
  border: 4px solid #f0f0f0;
  transition: all 0.3s ease;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: white;
  font-size: 14px;
}

.avatar-overlay i {
  font-size: 24px;
  margin-bottom: 4px;
}

.avatar-section:hover .avatar-overlay {
  opacity: 1;
}

.avatar-section:hover .user-avatar {
  transform: scale(1.05);
}

/* 信息区域 */
.info-section {
  flex: 1;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.user-name {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.user-descriptions {
  margin-top: 20px;
}

.user-descriptions i {
  margin-right: 4px;
  color: var(--primary-color);
}

/* 功能卡片 */
.function-card,
.calendar-card {
  height: 100%;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: var(--text-primary);
}

.card-header i {
  color: var(--primary-color);
  font-size: 18px;
}

/* 密码表单 */
.password-form {
  padding: 20px 0;
}

/* 即将推出 */
.coming-soon {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.coming-soon i {
  font-size: 64px;
  color: var(--border-color);
  margin-bottom: 16px;
}

.coming-soon p {
  font-size: 14px;
  margin: 0;
}

/* 日历样式 */
.calendar-card ::v-deep .el-calendar-table {
  font-size: 12px;
}

.calendar-card ::v-deep .el-calendar-table .el-calendar-day {
  height: 50px;
  padding: 4px;
}

.calendar-card ::v-deep .el-calendar__title {
  color: var(--text-primary);
  font-weight: 600;
}

/* 头像对话框 */
.avatar-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 20px 0;
}

.preview-avatar {
  border: 3px solid var(--primary-color);
  box-shadow: var(--shadow-md);
}

.upload-btn {
  width: 100%;
  text-align: center;
}

/* 响应式 */
@media (max-width: 768px) {
  .user-info-content {
    flex-direction: column;
    text-align: center;
  }

  .info-header {
    justify-content: center;
  }
}
</style>
